import dayjs from "dayjs";
import { lazy } from "react";
import styles from "./styles.module.scss";

const Chart = lazy(() => import("./Chart"));

const Infographic = (props: {
  finalMark: number;
  correctCount: number;
  wrongCount: number;
  uncheckedCount: number;
  totalCount: number;
  examName: string;
  date?: string;
}) => {
  const {
    finalMark,
    correctCount,
    uncheckedCount,
    wrongCount,
    examName,
    totalCount,
    date
  } = props;

  return (
    <section className={styles["infographic"]}>
      <div className={styles["infographic__header"]}>
        <h2 className={styles["infographic__header-title"]}>{examName}</h2>
        <span className={styles["infographic__header-date"]}>
          {dayjs(date).calendar("jalali").format("YYYY/MM/DD")}
        </span>
      </div>
      <div className={styles["infographic__divider"]} />
      <div className={styles["infographic__data"]}>
        <div className={styles["infographic__data-stats"]}>
          <div className={styles["infographic__data-stats__mobile"]}>
            <div>
              <div
                className={styles["infographic__data-stats__mobile--correct"]}
              />
              <span>درست زدی</span>
            </div>
            <span>{correctCount} سوال</span>
          </div>
          <div className={styles["infographic__data-stats__mobile"]}>
            <div>
              <div
                className={styles["infographic__data-stats__mobile--wrong"]}
              />
              <span>غلط زدی</span>
            </div>
            <span>{wrongCount} سوال</span>
          </div>
          <div className={styles["infographic__data-stats__mobile"]}>
            <div>
              <div
                className={styles["infographic__data-stats__mobile--empty"]}
              />
              <span>اصلا نزدی</span>
            </div>
            <span>{uncheckedCount} سوال</span>
          </div>

          <div className={styles["infographic__data-stats__desktop"]}>
            <div className={styles["infographic__data-stats__desktop-title"]}>
              <div
                className={
                  styles["infographic__data-stats__desktop-title--correct"]
                }
              />
              <span>درست زدی</span>
            </div>
            <div
              className={styles["infographic__data-stats__desktop-divider"]}
            />
            <div className={styles["infographic__data-stats__desktop-count"]}>
              {correctCount} سوال
            </div>
            <div className={styles["infographic__data-stats__desktop-percent"]}>
              {Math.round((correctCount / totalCount) * 100)} درصد
            </div>
          </div>

          <div className={styles["infographic__data-stats__desktop"]}>
            <div className={styles["infographic__data-stats__desktop-title"]}>
              <div
                className={
                  styles["infographic__data-stats__desktop-title--wrong"]
                }
              />
              <span>غلط زدی</span>
            </div>
            <div
              className={styles["infographic__data-stats__desktop-divider"]}
            />
            <div className={styles["infographic__data-stats__desktop-count"]}>
              {wrongCount} سوال
            </div>
            <div className={styles["infographic__data-stats__desktop-percent"]}>
              {Math.round((wrongCount / totalCount) * 100)} درصد
            </div>
          </div>

          <div className={styles["infographic__data-stats__desktop"]}>
            <div className={styles["infographic__data-stats__desktop-title"]}>
              <div
                className={
                  styles["infographic__data-stats__desktop-title--empty"]
                }
              />
              <span>اصلا نزدی</span>
            </div>
            <div
              className={styles["infographic__data-stats__desktop-divider"]}
            />
            <div className={styles["infographic__data-stats__desktop-count"]}>
              {uncheckedCount} سوال
            </div>
            <div className={styles["infographic__data-stats__desktop-percent"]}>
              {Math.round((uncheckedCount / totalCount) * 100)} درصد
            </div>
          </div>
        </div>

        <div className={styles["infographic__data-chart"]}>
          <Chart {...props} />
          <span>{finalMark.toFixed(1)}%</span>
        </div>
      </div>
    </section>
  );
};

export default Infographic;
